export function validateGeoDataMapResponse(geoJson, translations) {
  const geoDataMapTranslation = translations.entry.geo_data_map
  const { errors, status_code, data: geoJsonData } = geoJson

  if (status_code !== 200) {
    const messages = [...geoDataMapTranslation.default_error_messages]
    if (errors?.length > 0) {
      messages.push(...errors)
    }
    return messages
  }

  const { points, polygons, polygon_centroids } = geoJsonData
  if (!points || !polygons || !polygon_centroids) {
    return [
      ...geoDataMapTranslation.default_error_messages,
      geoDataMapTranslation.server_not_returning_correct_data
    ]
  }

  return []
}
